<template lang="pug">
  .container
    .max-width-grid
      intro
    carousel(carouselHeight="41rem")
      slide(:slideContent="OnlineRevenueSlide")
      slide(:slideContent="DemographicSlide")
      slide(:slideContent="BoughtOnlineSlide")
    .max-width-grid
      research-intro
    carousel(carouselHeight="78rem")
      slide(:slideContent="ShoppingTimelineSlide")
      slide(:slideContent="PopularGiftsSlide")
    .max-width-grid
      research-experience
    carousel(carouselHeight="58rem")
      slide(:slideContent="WhyExperienceSlide")
      slide(:slideContent="PopularGiftsSearchSlide")
      slide(:slideContent="SocialMediaRoleSlide")
    .max-width-grid
      evaluating-gift-options
    carousel(carouselHeight="63rem")
      slide(:slideContent="TakeawayOneSlide")
      slide(:slideContent="TakeawayTwoSlide")
    .max-width-grid
    evaluating-deals
    .max-width-grid
      purchasing-intro
    purchase-factors
    .max-width-grid
      gift-keeps-giving
      sources
</template>

<script>
import debug from 'debug'
import Intro from '../components/Intro'
import OnlineRevenueSlide from '../components/OnlineRevenueSlide'
import DemographicSlide from '../components/DemographicSlide'
import BoughtOnlineSlide from '../components/BoughtOnlineSlide'
import ResearchIntro from '../components/ResearchIntro'
import ShoppingTimelineSlide from '../components/ShoppingTimelineSlide'
import PopularGiftsSlide from '../components/PopularGiftsSlide'
import ResearchExperience from '../components/ResearchExperience'
import WhyExperienceSlide from '../components/WhyExperienceSlide'
import PopularGiftsSearchSlide from '../components/PopularGiftSearchSlide'
import SocialMediaRoleSlide from '../components/SocialMediaRoleSlide'
import EvaluatingGiftOptions from '../components/EvaluatingGiftOptions'
import TakeawayOneSlide from '../components/TakeawayOneSlide'
import TakeawayTwoSlide from '../components/TakeawayTwoSlide'
import EvaluatingDeals from '../components/EvaluatingDeals'
import PurchasingIntro from '../components/PurchasingIntro'
import PurchaseFactors from '../components/PurchaseFactors'
import GiftKeepsGiving from '../components/GiftKeepsGiving'
import Sources from '../components/Sources'
import Carousel from '../components/Carousel'
import Slide from '../components/Slide'

let log = debug('view:Container')

export default {
  name: 'container',
  data () {
    return {
      OnlineRevenueSlide,
      DemographicSlide,
      BoughtOnlineSlide,
      ShoppingTimelineSlide,
      PopularGiftsSlide,
      WhyExperienceSlide,
      PopularGiftsSearchSlide,
      SocialMediaRoleSlide,
      TakeawayOneSlide,
      TakeawayTwoSlide,
    }
  },
  mounted: function () {
    log('Mounted')
  },
  computed: {
  },
  methods: {
  },
  components: {
    Intro,
    Carousel,
    Slide,
    OnlineRevenueSlide,
    DemographicSlide,
    BoughtOnlineSlide,
    ResearchIntro,
    ShoppingTimelineSlide,
    PopularGiftsSlide,
    ResearchExperience,
    WhyExperienceSlide,
    PopularGiftsSearchSlide,
    SocialMediaRoleSlide,
    EvaluatingGiftOptions,
    TakeawayOneSlide,
    TakeawayTwoSlide,
    EvaluatingDeals,
    PurchasingIntro,
    PurchaseFactors,
    GiftKeepsGiving,
    Sources,
  },
}
</script>

<style scoped lang="scss">
.container {
  position: relative;
  // border-right: 1px solid red;
  // border-left: 1px solid red;
}
</style>
